var c = {};
Object.defineProperty(c, "__esModule", {
  value: !0
});
var T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, U = typeof window < "u" && typeof window.document < "u", R = typeof process < "u" && process.versions != null && process.versions.node != null, C = (typeof self > "u" ? "undefined" : T(self)) === "object" && self.constructor && self.constructor.name === "DedicatedWorkerGlobalScope", I = typeof window < "u" && window.name === "nodejs" || typeof navigator < "u" && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), $ = typeof Deno < "u" && typeof Deno.version < "u" && typeof Deno.version.deno < "u";
c.isBrowser = U;
c.isWebWorker = C;
var j = c.isNode = R;
c.isJsDom = I;
c.isDeno = $;
var a = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.TEST = "TEST", e.SMOKE = "SMOKE", e.DEV = "DEV", e.NONPROD = "NONPROD", e.PROD = "PROD", e))(a || {}), i = /* @__PURE__ */ ((e) => (e.GLOBAL = "GLOBAL", e.CHINA = "CHINA", e))(i || {}), m = /* @__PURE__ */ ((e) => (e["en-US"] = "en-US", e["de-DE"] = "de-DE", e))(m || {}), h = /* @__PURE__ */ ((e) => (e.INTERNAL = "internal", e.EXTERNAL_SUPPLIER = "external_supplier", e.EXTERNAL_CONTRACTOR = "external_contractor", e.EXTERNAL_PARTNER = "external_partner", e.TECHNICAL = "technical", e.POOLID = "poolid", e))(h || {});
const B = {
  iss: "https://ssoalpha.dvb.corpinter.net/v1",
  sub: "TESTUSER",
  aud: ["DAIVBADM"],
  exp: 3e10,
  iat: 0,
  azp: "DAIVBADM",
  email: "test.user@mercedes-benz.com",
  email_verified: !0,
  scope: ["groups", "offline_access", "openid", "email", "profile"],
  name: "Test User",
  preferred_username: "Test User",
  user_type: h.INTERNAL,
  aad_id: "test.user_daimler.com#EXT#@mercedesme.onmicrosoft.com",
  family_name: "User",
  given_name: "Test"
}, z = {
  locale: m["en-US"]
};
let l, u, d, p = {};
const H = "/oauth/token", w = "/api/portal/v1/user/store", s = async () => (l || (l = await b(H, "profile")), l), y = async (e) => {
  const t = e === "portal" ? "settings" : "user store", n = `${w}/${e}?${v()}`;
  return await b(n, t);
}, M = async (e, t) => {
  try {
    const n = await fetch(`${w}/${e}?${v()}`, {
      method: "PATCH",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(t)
    });
    if (!n.ok) throw await n.text();
  } catch {
    return console.error(
      "Portal Service: User store unreachable. Please open an issue on GitHub: https://git.i.mercedes-benz.com/MBOS/portal/issues/new?assignees=&labels=%F0%9F%90%9B+bug&template=01_bug_report.md."
    ), Promise.reject(new Error("User store unreachable."));
  }
};
function v() {
  return (!u || !d) && (u = D(), d = E()), new URLSearchParams([
    ["stage", u],
    ["region", d],
    ["source", location.pathname]
  ]);
}
async function b(e, t) {
  try {
    const n = await fetch(e, {
      method: "GET",
      headers: {
        accept: "application/json"
      }
    }), r = n.status, o = n.headers.get("content-type") ?? "";
    if (r !== 200 || !o.includes("application/json"))
      throw `Server returned status code ${r} and content type ${o}.`;
    return await n.json();
  } catch (n) {
    return k(t, [
      `Portal Service: Error reading ${t} information.`,
      n
    ]);
  }
}
function k(e, t) {
  const n = j || ["localhost", "127.0.0.1"].includes(location.hostname);
  return e !== "user store" && n ? x(e) : (console.error(t.join(" ")), null);
}
function x(e) {
  const t = {
    profile: B,
    settings: z
  };
  return p[e] || (console.info(
    `Portal Service: Local development without access to portal API detected. Returning mock ${e}.`
  ), p[e] = !0), t[e];
}
const D = () => {
  var e;
  switch ((e = window == null ? void 0 : window.location) == null ? void 0 : e.hostname) {
    case "portal.mbos.mercedes-benz.com":
    case "portal.mbos.mercedes-benz.com.cn":
      return a.PROD;
    case "portal-nonprod.mbos.mercedes-benz.com":
    case "portal-nonprod.mbos.mercedes-benz.com.cn":
      return a.NONPROD;
    case "portal-dev.mbos.mercedes-benz.com":
      return a.DEV;
    case "portal-nonprod.dvb.corpinter.net":
    case "portal-nonprod.dvb.corpinter.net.cn":
      return a.SMOKE;
    case "portal-dev.dvb.corpinter.net":
      return a.TEST;
    case "localhost":
    case "127.0.0.1":
    default:
      return a.LOCAL;
  }
}, E = () => {
  var e, t;
  return (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (t = (e = window == null ? void 0 : window.location) == null ? void 0 : e.hostname) != null && t.endsWith(".cn") ? i.CHINA : i.GLOBAL
  );
}, G = async () => {
  var e;
  return ((e = await y("portal")) == null ? void 0 : e.locale) ?? m["en-US"];
}, V = async (e, t) => !e || (t == null ? void 0 : t.trim().length) === 0 || !A(e, t) ? null : y(P(e, t)), W = async (e, t, n) => {
  let r;
  return e === "portal" ? r = "Please refrain from modifying data associated with application keys that you neither own nor have explicit permission to modify from the owner." : !e || e.trim().length < 6 ? r = "Application keys are required and have to be at least 6 characters in length." : !t || t.trim().length < 1 ? r = "Data keys are required and have to be at least 1 character in length." : A(e, t) ? n === void 0 && (r = "The supplied data is undefined.") : r = "All keys are required to be lowercase kebab or snake case.", r ? (console.error("Portal Service: Error updating user store. " + r), Promise.reject(new Error(r))) : M(P(e, t), n);
}, X = (e, t, n) => {
  const r = {
    [i.GLOBAL]: "",
    [i.CHINA]: "china"
  }[t ?? E()] ?? t, o = (n ?? D()).toLowerCase().replace(/^prod/, "");
  return ["/api", e, r, o].filter(Boolean).join("/").toLowerCase();
}, q = async () => {
  const e = await s();
  return e || Promise.reject("User profile not found.");
}, J = async () => {
  const e = await s();
  return (e == null ? void 0 : e.sub) ?? null;
}, Y = async () => {
  const e = await s();
  return e ? e.preferred_username ?? e.sub ?? null : null;
}, Z = async () => {
  const e = await s();
  return { given: (e == null ? void 0 : e.given_name) ?? "", family: (e == null ? void 0 : e.family_name) ?? "" };
}, Q = async () => {
  const e = await s(), t = `${(e == null ? void 0 : e.given_name) ?? ""} ${(e == null ? void 0 : e.family_name) ?? ""}`.trim();
  return ((e == null ? void 0 : e.name) ?? (t || "Unknown User")).toLowerCase().replace(/\b\w/g, (r) => r.toUpperCase());
}, K = async () => {
  var t;
  const e = await s();
  return ((t = e == null ? void 0 : e.email) == null ? void 0 : t.toLowerCase()) ?? null;
}, ee = async () => {
  const e = await s();
  return (e == null ? void 0 : e.email_verified) ?? null;
}, te = async () => {
  const e = await s();
  return (e == null ? void 0 : e.user_type) ?? null;
}, ne = async () => {
  var f;
  const t = [...((f = await s()) == null ? void 0 : f.sub) ?? "foobar"].reduce((N, O) => N + O.charCodeAt(0), 0), n = /* @__PURE__ */ new Date(), r = n.getFullYear(), L = (Date.UTC(r, n.getMonth(), n.getDate()) - Date.UTC(r, 0, 0)) / 24 / 60 / 60 / 1e3;
  return t * L;
}, _ = "de-DE", S = () => ({
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: !1,
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
}), F = (e) => {
  const t = new Date(e).toLocaleString(_, S()), [n, r, o] = t.split(", ")[0].split(".");
  return o ? `${o}-${r}-${n}` : n;
}, re = (e, t) => {
  const n = t === "long" ? "2-digit" : void 0, r = F(e), o = new Date(e).toLocaleString(_, {
    ...S(),
    second: n
  });
  return r === "Invalid Date" ? r : r + " " + o.split(", ")[1];
}, P = (e, t) => [e, t].filter(Boolean).join("/"), g = /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/, A = (e, t) => g.test(e) && (!t || g.test(t));
export {
  m as Locale,
  i as Region,
  a as Stage,
  h as UserTypes,
  F as formatDate,
  re as formatDatetime,
  X as getApiPath,
  K as getEmail,
  ee as getEmailVerified,
  V as getFromUserStore,
  Q as getFullName,
  G as getLocale,
  Z as getName,
  q as getProfile,
  ne as getRandomNumber,
  E as getRegion,
  D as getStage,
  J as getUserId,
  te as getUserType,
  Y as getUsername,
  W as putIntoUserStore
};
